import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=0344bcb4&scoped=true"
import script from "./login-form.vue?vue&type=script&lang=js"
export * from "./login-form.vue?vue&type=script&lang=js"
import style1 from "./login-form.vue?vue&type=style&index=1&id=0344bcb4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344bcb4",
  null
  
)

export default component.exports